import { ListState } from './useList.types';

export const getListOrDefault = <T>(state: ListState<T>): T[] =>
  state.tag === 'with-data' ? state.list : [];
export const isLoading = <T>(state: ListState<T>): boolean =>
  state.tag !== 'error' && state.loading;

export const isAllSelected = <T, ID>(
  state: ListState<T>,
  selecteds: ID[],
  idExtractor: (item: T) => ID,
): boolean => {
  if (state.tag === 'with-data') {
    for (let index = 0; index < state.list.length; index += 1) {
      const element = state.list[index];
      if (selecteds?.includes(idExtractor(element)) === false) {
        return false;
      }
    }
  }

  return true;
};
